module.exports = __webpack_public_path__ + "img/ProcessAlarm.de553f94.svg";